import { render, staticRenderFns } from "./MyQuestionaries.vue?vue&type=template&id=64c2dd14&scoped=true&"
import script from "./MyQuestionaries.vue?vue&type=script&lang=js&"
export * from "./MyQuestionaries.vue?vue&type=script&lang=js&"
import style0 from "./MyQuestionaries.vue?vue&type=style&index=0&id=64c2dd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2dd14",
  null
  
)

export default component.exports